/***
 *
 *   MESSAGE STYLES
 *   The reference has no inline banner component — it uses toasts and
 *   EmptyState. This follows the reference's card idiom instead: rounded-lg,
 *   a hairline in the status colour, and a 10% tinted fill, matching the way
 *   ticket chips and the danger cards are built there.
 *
 *   The previous version was rounded-2xl with p-8 and floated its icon.
 *
 **********/

const Style = {
    message: 'relative mb-4 flex w-full items-start gap-3 overflow-hidden rounded-lg border p-4',
    title: 'm-0 mb-1 text-base font-semibold',

    // colour keys are historical; the values are status tokens
    blueBg: 'border-primary-200 bg-primary-50 dark:border-primary-800 dark:bg-primary-900/30',
    blueText: 'text-primary-700 dark:text-primary-300',
    greenBg: 'border-success/25 bg-success/10',
    greenText: 'text-success',
    orangeBg: 'border-warning/25 bg-warning/10',
    orangeText: 'text-warning',
    redBg: 'border-error/25 bg-error/10',
    redText: 'text-error',

    icon: 'mt-0.5 shrink-0',
    content: 'min-w-0 flex-1 text-sm',
    close: `absolute right-3 top-3 h-4 w-4 cursor-pointer bg-transparent opacity-60 transition-opacity
    hover:opacity-100`,
    btn: 'mt-3',
};

export default Style;
